<template>
  <div class="atlas-root">
    <AtlasSystem v-if="$route.name === 'solarSystem'" />
    <div v-else class="notification is-light">
      Раздел в разработке.
    </div>
  </div>
</template>

<script>
import AtlasSystem from '../components/atlas/AtlasSystem'

export default {
  components: {
    AtlasSystem,
  },
}
</script>

<style scoped>
.atlas-root {
  width: 100%;
}
</style>
